"use strict";
(function () {

    /**
     * Автосохранение проекта в редакторе
     * @namespace Fotobook.commands.autosave
     */

    var self = Fotobook.commands.autosave = {

        /**
         * Состояние таймера автосохранения
         */
        _timer: -1,

        /**
         * Кука для хранения состояния автосохранения
         */
        _cookie: 'projectAutoSave',


        /**
         * Запустить таймер автосохранения
         */
        queue: function () {
            if (self._timer === -1) {
                self._timer = setTimeout(self.autosave, 1000 * Fotobook.config.data[Fotobook.Settings.AUTOSAVE_INTERVAL]);
            }
        },

        /**
         * Сохранить проект
         */
        autosave: function () {
            self._timer = -1;
            if (Fotobook.isModified) {
                Fotobook.isModified = false;
                $(document).triggerHandler(Fotobook.events.COMMANDS_LOCK);
                Fotobook.core.saveProject().then((response) => {
                    $(document).triggerHandler(Fotobook.events.COMMANDS_UNLOCK);
                    if (response.data.additional_message) {
                        Fotobook.book.saveProjectMessage(response.data.additional_message);
                    }
                    self.queue();
                }).catch(() => null);
            }
            self.queue();
        },

        /**
         * Активен ли таймер автосохранения
         *
         * @returns {boolean}
         */
        getStarted: function () {
            return self._timer > -1;
        },

        /**
         * Получить состояние автосохранения
         *
         * @returns {boolean}
         */
        getState: function () {
            var fromCookie = String(Fotobook.$cookies.get(self._cookie)) === "true";
            return (!!Fotobook.config.data[Fotobook.Settings.AUTOSAVE_AUTOSTART] || !!fromCookie) && !!Fotobook.store.state.user.id;
        },

        /**
         * Обработчик нажатия кнопки автосохранения
         */
        processCommand: function () {
            var $this = $(this),
                active = self.getStarted() && self.getState();

            $this.toggleClass("active", !active);
            Fotobook.$cookies.set(self._cookie, !active);
            if (active) {
                clearTimeout(self._timer);
                self._timer = -1;
            } else {
                self.queue();
            }
        },

        /**
         * Инициализация автосохранения
         */
        activate: function () {
            if (self.getState()) {
                const $button = $(".commands-button.autosave-project");
                if ($button.length && !$button.hasClass("active")) {
                    self.processCommand.call($button);
                }
            }
        },
    };

    $(document).on(Fotobook.events.ONLINE_EDITOR_STARTED, self.activate);
})();
